import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { getHuggg } from 'redux/modules/huggg';
import {
  isSuperHuggg,
  makeLandingTitle,
  makeReactionTitle
} from 'utilities/huggg';
import {
  createEmojiReaction,
  addReactionComment,
  getReactionComment,
  getReactionEmoji,
  getLoadingEmoji,
  getLoadingComment,
  getLoadingEmojiError,
  getLoadingCommentError,
  getReactionDisabled
} from 'redux/modules/reaction';
import { Dialog } from 'components/ui';
import { ReactionComment } from './components/ReactionComment';
import { ReactableMessage } from './components/ReactableMessage';
import { SecondaryButton, useThemeContext } from '@huggg/react-components';
import SuccessConfetti from 'components/SuccessConfetti/SuccessConfetti';
import { CSSTransition } from 'react-transition-group';
import './Reaction.css';

function ReactionContent({
  huggg,
  commentValue,
  emojiValue,
  loadingEmoji,
  loadingComment,
  loadingEmojiError,
  loadingCommentError,
  createEmojiReaction,
  addReactionComment,
  reactionDisabled,
  animate,
  includeCommentSection,
  title
}) {
  const { message = '' } = isSuperHuggg(huggg) ? huggg : huggg.message || {};

  return (
    <>
      <ReactableMessage
        loading={loadingEmoji}
        title={title}
        message={message}
        animate={animate}
        onEmojiReaction={createEmojiReaction}
        senderName={huggg.from_name}
        emoji={emojiValue}
        error={loadingEmojiError}
        reactionDisabled={reactionDisabled}
      />

      {includeCommentSection && emojiValue && (
        <ReactionComment
          loading={loadingComment}
          value={commentValue}
          onConfirm={addReactionComment}
          error={loadingCommentError}
        />
      )}
    </>
  );
}

function Reaction({
  includeCommentSection = false,
  animate = false,
  isDialog = false,
  huggg,
  commentValue,
  emojiValue,
  loadingEmoji,
  loadingComment,
  loadingEmojiError,
  loadingCommentError,
  createEmojiReaction,
  addReactionComment,
  reactionDisabled
}) {
  const {
    reaction: { enabled: themeEnabled }
  } = useThemeContext();

  const [open, setOpen] = useState(false); // Initially closed
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (!themeEnabled) {
      return;
    }
    const timeout = setTimeout(() => setOpen(true), 750); // Delay by 0.75 seconds
    return () => clearTimeout(timeout); // Clean up on unmount
  }, [themeEnabled]);

  const hugggTitle = useMemo(
    () => (isDialog ? makeReactionTitle(huggg) : makeLandingTitle(huggg)),
    [isDialog, huggg]
  );

  const content = (
    <CSSTransition
      in={!isDialog || showContent}
      timeout={300}
      classNames="reaction-content"
      unmountOnExit
    >
      <ReactionContent
        huggg={huggg}
        commentValue={commentValue}
        emojiValue={emojiValue}
        loadingEmoji={loadingEmoji}
        loadingComment={loadingComment}
        loadingEmojiError={loadingEmojiError}
        loadingCommentError={loadingCommentError}
        createEmojiReaction={createEmojiReaction}
        addReactionComment={addReactionComment}
        reactionDisabled={reactionDisabled}
        animate={animate}
        includeCommentSection={includeCommentSection}
        title={hugggTitle}
      />
    </CSSTransition>
  );

  return isDialog ? (
    <Dialog
      disableOverlayClick={!(emojiValue && commentValue)}
      visible={open}
      showCloseButton={showContent}
      onClose={() => setOpen(false)}
      closeButton={<SecondaryButton className="reaction-close-button" />}
    >
      <div
        style={{
          minHeight: 200,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <SuccessConfetti
          alt="Success"
          duration={'2s'}
          scale={1.5}
          onAnimationEnd={() => setShowContent(true)}
        />
        {content}
      </div>
    </Dialog>
  ) : (
    content
  );
}

const mapStateToProps = (state, ownProps) => {
  const huggg = getHuggg(state);

  const reactionDisabled =
    ownProps?.reactionDisabled ?? getReactionDisabled(state);

  const commentValue = getReactionComment(state);
  const emojiValue = getReactionEmoji(state);

  const loadingEmoji = getLoadingEmoji(state);
  const loadingComment = getLoadingComment(state);
  const loadingEmojiError = getLoadingEmojiError(state);
  const loadingCommentError = getLoadingCommentError(state);

  return {
    huggg,
    commentValue,
    emojiValue,
    loadingEmoji,
    loadingComment,
    loadingEmojiError,
    loadingCommentError,
    reactionDisabled
  };
};

export default connect(mapStateToProps, {
  createEmojiReaction,
  addReactionComment
})(Reaction);
